import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Box,
  Layers,
  ShoppingCart,
  Users,
  CreditCard,
  Star,
  BarChart3,
  Truck,
  Settings,
} from "lucide-react";

function Sidebar() {
  const navItems = [
    { name: "Dashboard", path: "/", icon: LayoutDashboard },
    { name: "Products", path: "/product", icon: Box },
    { name: "Categories", path: "/categories", icon: Layers },
    { name: "Orders", path: "/orders", icon: ShoppingCart },
    { name: "Users", path: "/users", icon: Users },
    { name: "Transactions", path: "/transactions", icon: CreditCard },
    { name: "Reviews", path: "/reviews", icon: Star },
    { name: "Reports", path: "/reports", icon: BarChart3 },
    { name: "Shipping", path: "/shipping", icon: Truck },
    { name: "Settings", path: "/settings", icon: Settings },
  ];

  return (
    <aside className="bg-[#FBF8F6] border-r border-gray-200 flex flex-col h-screen overflow-y-auto transition-all duration-200 w-16 sm:w-48 md:w-64">
      {/* Logo Section */}
      <div className="px-2 sm:px-4 md:px-6 py-6 sm:py-8 flex items-center gap-2 sm:gap-3 justify-center sm:justify-start">
        <img
          src="/images/logos/logo.png"
          alt="Logo"
          className="w-8 h-8 sm:w-auto sm:h-10"
        />
        <span className="hidden sm:inline bg-[#D88797] text-white text-[12px] px-2 py-0.5 rounded-full font-medium">
          Admin
        </span>
      </div>

      {/* Navigation Links */}
      <nav className="flex flex-col px-1 sm:px-2 md:px-4 gap-1">
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) => `
              flex items-center justify-center sm:justify-start gap-0 sm:gap-3 px-2 sm:px-4 py-3 text-xs sm:text-sm rounded-lg transition-all duration-200
              ${
                isActive
                  ? "bg-white text-[#0C0C0E] border border-gray-100"
                  : "text-[#7D828D] hover:bg-white hover:text-[#0C0C0E]"
              }
            `}
            style={{ minWidth: 0, overflow: "hidden" }}
          >
            <item.icon size={20} strokeWidth={1.5} />
            <span className="hidden sm:inline font-medium truncate max-w-[120px]">
              {item.name}
            </span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
